import { AUTH, ROUTE } from '@/constants';
import { loadView } from '../index';

const OperatorLogsDashboardView = loadView(
  'operator-logs/OperatorLogsDashboardView',
);

const operatorLogsRoute = {
  path: ROUTE.PATH.OPERATOR_LOGS,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.OPERATOR_LOGS,
      component: OperatorLogsDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
      },
    },
    {
      path: ROUTE.PATH.OPERATOR_LOGS_DASHBOARD,
      name: ROUTE.NAME.OPERATOR_LOGS_DASHBOARD,
      component: OperatorLogsDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
      },
    },
  ],
};

export default operatorLogsRoute;
